import { notifyPasswordChanged as notifyPasswordChangedCallable } from '@griply/services';
import {
  AuthErrorKind,
  AuthFlow,
  PasswordChangeNoticeOutcome,
} from '@griply/types';
import { mapAuthError } from '@griply/utils';
import { httpsCallable } from 'firebase/functions';

import { getFunctions, reportAuthError } from './helpers';

const ACCEPTED_OUTCOMES: unknown[] = [
  PasswordChangeNoticeOutcome.Sent,
  PasswordChangeNoticeOutcome.RateLimited,
];

// Best effort and never rejects: the password already changed, and the notice must not undo that for the user.
export const notifyPasswordChanged = async (): Promise<void> => {
  try {
    const { outcome } = await notifyPasswordChangedCallable({
      functions: getFunctions(),
      httpsCallable,
    });
    if (ACCEPTED_OUTCOMES.includes(outcome)) {
      return;
    }
    reportAuthError(
      new Error('users-notifyPasswordChanged refused the notice'),
      AuthFlow.PasswordChangeNotice,
      { outcome },
    );
  } catch (error) {
    if (mapAuthError(error) === AuthErrorKind.Network) {
      return;
    }
    reportAuthError(error, AuthFlow.PasswordChangeNotice);
  }
};
